import { Search } from './../../shared/user.model';
import { Component, OnInit ,AfterViewInit} from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';
import { debugOutputAstAsTypeScript } from '@angular/compiler';



@Component({
  selector: 'app-approvals-grid',
  templateUrl: './approvals-grid.component.html',
  styleUrls: ['./approvals-grid.component.css']
})
export class ApprovalsGridComponent implements OnInit {
  title = "Applications List";
  sainikSchemeApplications=null;  
  itemsPerPage: number=5;
  currentPage: number=1;
  totalItems: number;
  isSearch:boolean;
  s: Search;
  userName: string;
  
  Action: string;

  constructor(private userService: RegistrationService, private router: Router, private errorHandler:ErrorHandler)  
  { 
    this.s=new Search();
    this.isSearch = false;
    this.userName = localStorage.getItem("userName");
  }  
  ngOnInit() 
  { 
    debugger;
    this.Action="Pending";
    this.title="Applications Action Pending With " + this.userName;
    this.GetAllApplicationsToActByTheUser(this.itemsPerPage,1);
    //rdo.checked=true;
  }

  pageChanged(pageNumber:number)
  {   
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else
    {
    var values =  (<HTMLInputElement>document.querySelector('input[name="Action"]:checked')).value;
    
    if (values == "Pending")
    {      
      this.title="Applications Action Pending With " + this.userName;
      this.GetAllApplicationsToActByTheUser(this.itemsPerPage, pageNumber);
    }
    if (values == "Others")
    {      
      this.title="Applications Action Pending With Others";
      this.GetAllApplicationToActByOthers(this.itemsPerPage,pageNumber);
    }
    if (values == "Closed")
    {
      this.title="Applications Approved/Rejected" ;
      this.GetAllApplicationsClosed(this.itemsPerPage,1);
    }
  }
  }
  
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) 
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    else
    {
        var values =  (<HTMLInputElement>document.querySelector('input[name="Action"]:checked')).value;
        if (values == "Pending")
        {
          this.title="Applications Action Pending With " + this.userName;
          this.GetAllApplicationsToActByTheUser(this.itemsPerPage, pageNo);
        }
        if (values == "Others")
        {
          this.title="Applications Action Pending With Others"
          this.GetAllApplicationToActByOthers(this.itemsPerPage,pageNo);
        }
        if (values == "Closed")
        {
          this.title="Applications Approved/Rejected" ;
          this.GetAllApplicationsClosed(this.itemsPerPage,1);
        }
    }
  }
  
  GetAllApplicationsToActByTheUser(itemsPerPage: number, pageNo: number) 
  { 
    document.getElementById('loader-spinner').style.display = "block";
    debugger;
    this.userService.getAllApplicationsToBeApprovedByTheUser(itemsPerPage,pageNo)
      .subscribe(
        (data:any) => {
          this.sainikSchemeApplications=data.sainikSchemeApplicationModels;
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });        
  }

  onItemChange(radioSelected:string)
  {
    debugger;
    
    if (radioSelected == "Pending")
    {
      this.title="Applications Action Pending With " + this.userName;
      this.GetAllApplicationsToActByTheUser(this.itemsPerPage,1);
    }
    if (radioSelected == "Others")
    { 
      this.title="Applications Action Pending With Others" ;
      this.GetAllApplicationToActByOthers(this.itemsPerPage,1);
    }
    if (radioSelected == "Closed")
    {
      this.title="Applications Approved/Rejected" ;
      this.GetAllApplicationsClosed(this.itemsPerPage,1);
    }
  }

  GetAllApplicationToActByOthers(itemsPerPage:number,pageNo: number)
  {
    
    document.getElementById('loader-spinner').style.display = "block";
    debugger;
    this.userService.getAllApplicationsToBeApprovedByOthers(itemsPerPage,pageNo)
      .subscribe(
        (data:any) => {
          this.sainikSchemeApplications=data.sainikSchemeApplicationModels;
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  GetAllApplicationsClosed(itemsPerPage:number,pageNo:number)
  {
    
    document.getElementById('loader-spinner').style.display = "block";
    debugger;
    this.userService.getAllApplicationsClosed(itemsPerPage,pageNo)
      .subscribe(
        (data:any) => {
          this.sainikSchemeApplications=data.sainikSchemeApplicationModels;
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  onSearch(s,itemsPerPage: number, pageNo: number) 
 {
   debugger;
   var searchText = this.s.SearchText;
   var searchCriteria = this.s.SearchCriteria;
   if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
     swal("Warning!", "Please enter the search criteria and search text.", "warning");
   else {
     document.getElementById('loader-spinner').style.display = "block";     
     var values =  (<HTMLInputElement>document.querySelector('input[name="Action"]:checked')).value;     
     this.userService.searchApplications(searchCriteria, searchText, itemsPerPage, pageNo,values)
       .subscribe(
         (data:any) => {
           debugger;
           this.sainikSchemeApplications=data.sainikSchemeApplicationModels;
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
           document.getElementById('loader-spinner').style.display = "none";
         }, (error:any) => {
           document.getElementById('loader-spinner').style.display = "none";
           this.errorHandler.HandlerError(error);
         });
   }
 }
}


// WEBPACK FOOTER //
// ./src/app/schemes/approvals-grid/approvals-grid.component.ts